import React from 'react';
import { Link } from 'react-router-dom';

/* Blog data + card artwork, shared by the blog index and the "keep reading"
   rail on each article. Colours: accent strokes use currentColor (set in
   src/styles/pages/blog.css), ink strokes stay near-black at low opacity. */

export const blogPosts = [
  {
    slug: 'clinician-burnout-ai-automation',
    title: 'Clinician Burnout Is Costing Canada\'s Healthcare System — Here\'s How AI Automation Can Fix It',
    excerpt:
      'Two in five healthcare workers say their jobs are unsustainable. AI automation can save 20+ hours per week and reduce burnout risk by 74%. Here\'s what Canadian clinics can deploy today.',
    date: 'Mar 30, 2026',
    iso: '2026-03-30',
    category: 'Healthcare AI',
    read: 7,
  },
  {
    slug: 'canadas-automated-decision-making-directive',
    title: 'Canada\'s Automated Decision-Making Directive: What Public Sector Vendors Must Do Before June 2026',
    excerpt:
      'The hard compliance deadline is three months away. A step-by-step guide to Algorithmic Impact Assessments, human-in-the-loop requirements, and a 90-day remediation checklist for federal departments and their vendors.',
    date: 'Mar 19, 2026',
    iso: '2026-03-19',
    category: 'Public Sector',
    read: 6,
  },
  {
    slug: 'connected-care-for-canadians-act',
    title: 'The Connected Care for Canadians Act: What Clinic and Health System Operators Need to Know',
    excerpt:
      'Canada\'s new federal health data legislation enables cross-provincial data sharing and AI governance. Here\'s what it means for your clinic\'s data infrastructure, EHR interoperability, and AI workflows.',
    date: 'Mar 19, 2026',
    iso: '2026-03-19',
    category: 'Healthcare',
    read: 7,
  },
  {
    slug: 'ai-automation-for-canadian-clinics',
    title: 'AI Automation for Canadian Clinics: 7 Workflows You Can Deploy in 30 Days',
    excerpt:
      'A practical, privacy-first guide to deploy seven high-impact workflows in four weeks without disrupting patient care.',
    date: 'Feb 16, 2026',
    iso: '2026-02-16',
    category: 'Healthcare AI',
    read: 2,
  },
];

const cardIllustrations = {
 'clinician-burnout-ai-automation': (
  <svg viewBox="0 0 600 200" fill="none">
   <rect className="illo-bg" width="600" height="200" />
   {/* Heartbeat line */}
   <polyline points="0,120 80,120 120,120 140,60 160,160 180,90 200,130 220,120 340,120" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" opacity=".6" />
   <polyline points="340,120 600,120" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" opacity=".2" />
   {/* Stethoscope icon */}
   <circle cx="460" cy="100" r="36" stroke="#1A1714" strokeWidth="2.5" fill="none" opacity=".12" />
   <circle cx="460" cy="100" r="18" stroke="currentColor" strokeWidth="2" fill="none" opacity=".3" />
   <path d="M460 82 L460 60 Q460 45 475 45 L480 45" stroke="#1A1714" strokeWidth="2" fill="none" opacity=".12" strokeLinecap="round" />
   {/* Plus signs */}
   <g opacity=".15" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="90" y1="50" x2="90" y2="70" /><line x1="80" y1="60" x2="100" y2="60" />
    <line x1="520" y1="140" x2="520" y2="160" /><line x1="510" y1="150" x2="530" y2="150" />
    <line x1="300" y1="40" x2="300" y2="55" /><line x1="292" y1="47" x2="308" y2="47" />
   </g>
   {/* Gear / automation */}
   <circle cx="540" cy="60" r="22" stroke="#1A1714" strokeWidth="2" fill="none" opacity=".08" />
   <circle cx="540" cy="60" r="8" fill="currentColor" opacity=".15" />
   {/* Tiny dots */}
   <circle cx="150" cy="40" r="3" fill="currentColor" opacity=".12" />
   <circle cx="400" cy="160" r="4" fill="currentColor" opacity=".1" />
   <circle cx="250" cy="170" r="2.5" fill="#1A1714" opacity=".08" />
  </svg>
 ),
 'canadas-automated-decision-making-directive': (
  <svg viewBox="0 0 600 200" fill="none">
   <rect className="illo-bg" width="600" height="200" />
   {/* Shield */}
   <path d="M290 45 L290 130 Q290 160 320 175 Q350 160 350 130 L350 45 Q320 35 290 45Z" stroke="#1A1714" strokeWidth="2.5" fill="none" opacity=".12" />
   <path d="M305 90 L315 102 L340 75" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" opacity=".5" />
   {/* Document lines */}
   <g opacity=".1" stroke="#1A1714" strokeWidth="2" strokeLinecap="round">
    <line x1="80" y1="60" x2="170" y2="60" />
    <line x1="80" y1="80" x2="150" y2="80" />
    <line x1="80" y1="100" x2="160" y2="100" />
    <line x1="80" y1="120" x2="130" y2="120" />
   </g>
   <rect x="70" y="45" width="115" height="95" rx="6" stroke="#1A1714" strokeWidth="2" fill="none" opacity=".08" />
   {/* Scale / balance */}
   <line x1="460" y1="55" x2="460" y2="140" stroke="#1A1714" strokeWidth="2" opacity=".1" />
   <line x1="420" y1="80" x2="500" y2="80" stroke="#1A1714" strokeWidth="2" opacity=".1" />
   <path d="M420 80 L410 110 L430 110 Z" stroke="currentColor" strokeWidth="1.5" fill="currentColor" opacity=".12" />
   <path d="M500 80 L490 110 L510 110 Z" stroke="currentColor" strokeWidth="1.5" fill="currentColor" opacity=".12" />
   {/* Maple leaf accent */}
   <circle cx="460" cy="55" r="8" fill="currentColor" opacity=".15" />
   {/* Dots */}
   <circle cx="250" cy="160" r="3" fill="currentColor" opacity=".1" />
   <circle cx="540" cy="150" r="4" fill="currentColor" opacity=".08" />
   <circle cx="390" cy="170" r="2.5" fill="#1A1714" opacity=".06" />
  </svg>
 ),
 'connected-care-for-canadians-act': (
  <svg viewBox="0 0 600 200" fill="none">
   <rect className="illo-bg" width="600" height="200" />
   {/* Connected nodes */}
   <circle cx="200" cy="100" r="28" stroke="currentColor" strokeWidth="2.5" fill="none" opacity=".25" />
   <circle cx="400" cy="100" r="28" stroke="currentColor" strokeWidth="2.5" fill="none" opacity=".25" />
   <circle cx="300" cy="60" r="22" stroke="#1A1714" strokeWidth="2" fill="none" opacity=".12" />
   <circle cx="300" cy="145" r="22" stroke="#1A1714" strokeWidth="2" fill="none" opacity=".12" />
   {/* Connection lines */}
   <line x1="225" y1="88" x2="282" y2="68" stroke="currentColor" strokeWidth="1.5" opacity=".2" />
   <line x1="318" y1="68" x2="375" y2="88" stroke="currentColor" strokeWidth="1.5" opacity=".2" />
   <line x1="225" y1="112" x2="282" y2="137" stroke="currentColor" strokeWidth="1.5" opacity=".2" />
   <line x1="318" y1="137" x2="375" y2="112" stroke="currentColor" strokeWidth="1.5" opacity=".2" />
   <line x1="200" y1="100" x2="400" y2="100" stroke="currentColor" strokeWidth="1.5" opacity=".12" strokeDasharray="6 4" />
   {/* Inner icons — simplified FHIR "fire" */}
   <circle cx="200" cy="100" r="10" fill="currentColor" opacity=".15" />
   <circle cx="400" cy="100" r="10" fill="currentColor" opacity=".15" />
   <circle cx="300" cy="60" r="8" fill="#1A1714" opacity=".06" />
   <circle cx="300" cy="145" r="8" fill="#1A1714" opacity=".06" />
   {/* Outer satellite dots */}
   <circle cx="100" cy="70" r="12" stroke="#1A1714" strokeWidth="1.5" fill="none" opacity=".06" />
   <line x1="112" y1="74" x2="173" y2="92" stroke="#1A1714" strokeWidth="1" opacity=".06" />
   <circle cx="500" cy="130" r="12" stroke="#1A1714" strokeWidth="1.5" fill="none" opacity=".06" />
   <line x1="488" y1="126" x2="427" y2="108" stroke="#1A1714" strokeWidth="1" opacity=".06" />
   {/* Data flow arrows */}
   <g opacity=".12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <line x1="80" y1="160" x2="120" y2="160" />
    <polyline points="115,155 120,160 115,165" />
    <line x1="480" y1="45" x2="520" y2="45" />
    <polyline points="515,40 520,45 515,50" />
   </g>
  </svg>
 ),
 'ai-automation-for-canadian-clinics': (
  <svg viewBox="0 0 600 200" fill="none">
   <rect className="illo-bg" width="600" height="200" />
   {/* Workflow arrows — stepped pipeline */}
   <g opacity=".12" stroke="#1A1714" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="60" y="75" width="80" height="50" rx="8" />
    <rect x="190" y="75" width="80" height="50" rx="8" />
    <rect x="320" y="75" width="80" height="50" rx="8" />
    <rect x="450" y="75" width="80" height="50" rx="8" />
   </g>
   {/* Arrow connectors */}
   <g opacity=".25" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="143" y1="100" x2="187" y2="100" />
    <polyline points="182,95 187,100 182,105" />
    <line x1="273" y1="100" x2="317" y2="100" />
    <polyline points="312,95 317,100 312,105" />
    <line x1="403" y1="100" x2="447" y2="100" />
    <polyline points="442,95 447,100 442,105" />
   </g>
   {/* Step labels — small icons in boxes */}
   <circle cx="100" cy="95" r="10" fill="currentColor" opacity=".15" />
   <circle cx="230" cy="95" r="10" fill="currentColor" opacity=".12" />
   <circle cx="360" cy="95" r="10" fill="currentColor" opacity=".1" />
   <circle cx="490" cy="95" r="10" fill="currentColor" opacity=".18" />
   {/* Checkmark on last */}
   <path d="M484 95 L488 100 L498 88" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" opacity=".4" />
   {/* Calendar — 30 day hint */}
   <rect x="490" y="35" width="40" height="35" rx="4" stroke="#1A1714" strokeWidth="1.5" fill="none" opacity=".08" />
   <line x1="490" y1="47" x2="530" y2="47" stroke="#1A1714" strokeWidth="1.5" opacity=".08" />
   <text x="510" y="62" textAnchor="middle" fontSize="11" fontFamily="'Inter', sans-serif" fill="currentColor" opacity=".2" fontWeight="600">30</text>
   {/* Decorative dots */}
   <circle cx="70" cy="45" r="3" fill="currentColor" opacity=".1" />
   <circle cx="350" cy="165" r="4" fill="currentColor" opacity=".08" />
   <circle cx="160" cy="155" r="2.5" fill="#1A1714" opacity=".06" />
   <circle cx="530" cy="155" r="3" fill="#1A1714" opacity=".06" />
  </svg>
 )
};

export function BlogCardArt({ slug }) {
  const art = cardIllustrations[slug];
  if (!art) return null;
  return <div className="blog-illo blog-card-art" aria-hidden="true">{art}</div>;
}

/** Whole card is clickable (stretched title link); keyboard focus lands on the title link. */
export function BlogCard({ post, headingLevel: H = 'h3', className = '' }) {
  return (
    <article className={`blog-card stretch-host ${className}`} data-cursor="Read">
      <div className="blog-card__art">
        <BlogCardArt slug={post.slug} />
      </div>
      <div className="blog-card__body">
        <p className="blog-card__meta">
          <span className="blog-chip">{post.category}</span>
          <time dateTime={post.iso}>{post.date}</time>
          <span aria-hidden="true" className="blog-card__dot" />
          <span>{post.read} min read</span>
        </p>
        <H className="blog-card__title">
          <Link to={`/blog/${post.slug}`} className="blog-card__link link-stretch">{post.title}</Link>
        </H>
        <p className="blog-card__excerpt">{post.excerpt}</p>
        <span className="blog-card__cta" aria-hidden="true">
          Read Article <i className="fa-solid fa-arrow-right" />
        </span>
      </div>
    </article>
  );
}
